
import React from 'react';

interface StatItemProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  description?: string;
  className?: string;
  iconClassName?: string;
}

const StatItem: React.FC<StatItemProps> = ({ 
  title, 
  value, 
  icon, 
  description,
  className = "",
  iconClassName = "bg-gray-100"
}) => {
  return (
    <div className={`p-6 rounded-xl shadow-sm transition-all duration-300 transform hover:-translate-y-1 hover:shadow-md ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-700">{title}</h3>
        <div className={`p-2 rounded-lg ${iconClassName}`}>
          {icon}
        </div>
      </div>
      <div className="space-y-1">
        <div className="text-2xl font-bold text-gray-900">{value}</div>
        {description && (
          <p className="text-sm text-gray-500">{description}</p>
        )}
      </div>
    </div>
  );
};

export default StatItem;
